var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_2656",
    "data-name": "Group 2656",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18,
    height: 16.164,
    viewBox: "0 0 18 16.164",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1775",
    "data-name": "Rectangle 1775",
    width: 18,
    height: 16.164,
    fill: "#474747"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2655",
    "data-name": "Group 2655",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3700",
    "data-name": "Path 3700",
    d: "M16.1,0H1.9A1.843,1.843,0,0,0,0,1.9v9.081a1.9,1.9,0,0,0,1.9,1.9H4.5V11.382H1.9a.4.4,0,0,1-.4-.4V1.9a.358.358,0,0,1,.4-.4H16.1a.4.4,0,0,1,.4.4v9.081a.4.4,0,0,1-.4.4H13.459v1.492H16.1a1.9,1.9,0,0,0,1.9-1.9V1.9A1.9,1.9,0,0,0,16.1,0",
    transform: "translate(0 -0.001)",
    fill: "#474747"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3701",
    "data-name": "Path 3701",
    d: "M65.5,76.753l-.846.879V71.889a.746.746,0,0,0-1.492,0v5.779l-.939-.948a.746.746,0,1,0-1.061,1.05l2.215,2.238a.746.746,0,0,0,.53.221h.005A.746.746,0,0,0,64.446,80l2.13-2.212A.746.746,0,0,0,65.5,76.753",
    transform: "translate(-54.884 -64.065)",
    fill: "#474747"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.c0a9b7446254e995e2fa7e29d7cc2662.svg";
export { ForwardRef as ReactComponent };